// Remove fallback url for welcome dashboard once PreProd version is deployed to remove the contactId parameter
const WELCOME_DASHBOARD_URL = '/api/v3/customer/welcomedashboard';

const warnDegradedEndpoint = (canonical, fallback) => {
  // eslint-disable-next-line no-console
  console.warn(
    `[API Degradation] "${canonical}" is degraded. Requests are being routed to the fallback endpoint. Restore once the endpoint is up to date.`
  );
};

export const getWelcomeDashboardUrl = (isFallback, contactId) => {
  if (isFallback) {
    const fallbackUrl = `${WELCOME_DASHBOARD_URL}/${contactId}`;
    warnDegradedEndpoint(WELCOME_DASHBOARD_URL, fallbackUrl);
    return fallbackUrl;
  }
  return WELCOME_DASHBOARD_URL;
};
